export function isOwnerPath(pathname: string): boolean {
  return pathname === "/owner" || pathname.startsWith("/owner/");
}

export function isAdminPath(pathname: string): boolean {
  return pathname === "/admin" || pathname.startsWith("/admin/");
}

export const OWNER_NOTIFICATIONS_PATH = "/owner/notifications";
export const OWNER_SETTINGS_PATH = "/owner/settings";
export const MANAGER_NOTIFICATIONS_PATH = "/notifications";
export const MANAGER_SETTINGS_PATH = "/settings";
export const ADMIN_NOTIFICATIONS_PATH = "/admin/notifications";
export const ADMIN_NOTIFICATION_SETTINGS_PATH = "/admin/account";
